import {
  $getNodeByKey,
  $createRangeSelection,
  $setSelection,
} from 'lexical';
import { $patchStyleText } from '@lexical/selection';

export function applyBlockTextColor(editor, nodeKey, color) {
  editor.update(() => {
    const node = $getNodeByKey(nodeKey);
    if (!node) return;

    const firstChild = node.getFirstDescendant();
    const lastChild = node.getLastDescendant();
    if (!firstChild || !lastChild) return;

    const rangeSelection = $createRangeSelection();
    rangeSelection.anchor.set(
      firstChild.getKey(),
      0,
      firstChild.getType() === 'text' ? 'text' : 'element'
    );
    rangeSelection.focus.set(
      lastChild.getKey(),
      lastChild.getType() === 'text' ? lastChild.getTextContentSize() : lastChild.getChildrenSize(),
      lastChild.getType() === 'text' ? 'text' : 'element'
    );

    $setSelection(rangeSelection);

    if (color === '') {
      const nodes = rangeSelection.getNodes();
      nodes.forEach((n) => {
        if (n.getType() === 'text') {
          const currentStyle = n.getStyle();
          const newStyle = currentStyle.replace(/color:\s*[^;]+;?/g, '').trim();
          n.setStyle(newStyle);
        }
      });
    } else {
      $patchStyleText(rangeSelection, { color });
    }
  });
}

export function applyBlockBackgroundColor(editor, nodeKey, bgColor) {
  editor.update(() => {
    const node = $getNodeByKey(nodeKey);
    if (!node) return;

    const firstChild = node.getFirstDescendant();
    const lastChild = node.getLastDescendant();
    if (!firstChild || !lastChild) return;

    const rangeSelection = $createRangeSelection();
    rangeSelection.anchor.set(
      firstChild.getKey(),
      0,
      firstChild.getType() === 'text' ? 'text' : 'element'
    );
    rangeSelection.focus.set(
      lastChild.getKey(),
      lastChild.getType() === 'text' ? lastChild.getTextContentSize() : lastChild.getChildrenSize(),
      lastChild.getType() === 'text' ? 'text' : 'element'
    );

    $setSelection(rangeSelection);

    if (bgColor === '') {
      const nodes = rangeSelection.getNodes();
      nodes.forEach((n) => {
        if (n.getType() === 'text') {
          const currentStyle = n.getStyle();
          const newStyle = currentStyle.replace(/background-color:\s*[^;]+;?/g, '').trim();
          n.setStyle(newStyle);
        }
      });
    } else {
      $patchStyleText(rangeSelection, { 'background-color': bgColor });
    }
  });
}
